import {
  titleUI,
  textUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { customTextSchema } from '../../definitions';
import content from '../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['child-relationship-title']),
    childRelationship: textUI({
      title: content['child-relationship-question'],
    }),
  },
  schema: {
    type: 'object',
    required: ['childRelationship'],
    properties: {
      childRelationship: customTextSchema,
    },
  },
};
